import testimage1 from "../../Assets/Picture1.png";
import home3 from "../../Assets/home3.png";
import testimage2 from "../../Assets/Picture2.png";
import { useTranslation } from 'react-i18next';
import "./Home1.css";

const HomeComponent = () => {
  const { t } = useTranslation('home');

  return (
      <div
        className="HomeComponent"
        style={{
          backgroundColor: "white",
        }}
      >
        <div
          className="content-wrapper"
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          {/* Objectives & Activities Section */}
          <div className="left" style={{ flex: 1, margin: "10px", padding: "10%" }}>
            <h1 style={{ marginBottom: "20px", fontSize: "30px" }}>
              {t('objectives')}
            </h1>
            <h2 style={{ fontSize: "20px", lineHeight: "1.5",fontWeight: "normal" }}>
              {t('objectivesText')}
            </h2>
          </div>
    
          {/* Image Section */}
          <div className="right" style={{ flex: 1, textAlign: "center" }}>
            <img
              src={testimage1}
              alt="Objectives"
              style={{
                maxWidth: "500px",
                width: "100%",
                height: "auto",
                borderRadius: "10px",
              }}
            />
          </div>
        </div>
        
              
        {/* Target Group Section */}
        <div style={{ display: 'flex' }}>
          <div className='left' style={{ flex: 'none', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <img src={home3} alt="Description" style={{ maxWidth:'500px', width:'100%', height:'auto', borderRadius: '10px', padding:"3vw"  }} />
          </div>
          <div className='right' style={{ flex: 2, margin: '5%', paddingLeft: '10%', fontSize:"25px" }}>
            <h1>{t('targetGroup')}</h1>
            <ul>
              <ul className="target-group-list">
                {t('targetGroupText', { returnObjects: true }).split('\n').map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ul>
            </ul>
          </div>
        </div>
        

        {/* Outcomes Section */}
        <div className="outcomes" style={{ display: "flex", marginTop: "50px", marginBottom: "50px", padding: "10%" }}>
          <div className="left" style={{ flex: 1, textAlign: "center" }}>
            <img
              src={testimage2}
              alt="Outcomes"
              style={{
                maxWidth: "500px",
                width: "100%",
                height: "auto",
                borderRadius: "10px",
              }} />
          </div>
          <div className="right" style={{ flex: 1, marginLeft: "10px" }}>
            <h1 style={{ marginBottom: "20px", fontSize: "30px" }}>{t('outcomes')}</h1>
            <h2 style={{ fontSize: "20px", lineHeight: "1.5" ,fontWeight: "normal"}}>
              {t('outcomesText')}
            </h2>
          </div>
        </div>
    
        {/* Partnership Section */}
        <div className="partnership" style={{ marginTop: "50px", marginBottom: "50px", padding: "10%" }}>
          <h1 style={{ marginBottom: "20px", fontSize: "30px" }}>{t('partnership')}</h1>
          <h2 style={{ fontSize: "20px", lineHeight: "1.5", fontWeight: "normal" }}>
            {t('partnershipText')}
          </h2>
        </div>

        <h4 className="Date">{t('projectDuration')}</h4>
      </div> 
  )
}

export default HomeComponent;
